export default {
  // Header
  'header.home': 'Home',
  'header.about': 'About',
  'header.research': 'Research',
  'header.career': 'Career',
  'header.media': 'Media & Links',
  'header.blog': 'Blog & Articles',
  'header.contact': 'Contact',

  // Language Switcher
  'lang.ja': '日本語',
  'lang.en': 'English',

  // Common Buttons
  'common.viewProfile': 'View Profile',
  'common.contact': 'Contact',
  'common.readArticle': 'Read Article',
  'common.showMore': 'Show More',
  'common.viewAllArticles': 'View All Articles on note',
  'common.externalLink': 'External Link',
};
